export const REQUEST_RESULTS = 'REQUEST_RESULTS';
export const RECEIVE_RESULTS = 'RECEIVE_RESULTS';
export const CHANGE_QUERY = 'CHANGE_QUERY';
export const CLEAR_QUERY_RESULTS = 'CLEAR_QUERY_RESULTS';

import {post, apiRoutes} from './../../api/api';
import queryHelper from '../../helpers/queryHelper';

function requestResults(query) {
  return {
    type: REQUEST_RESULTS,
    query: query
  };
}

function receiveResults(response) {
  return {
    type: RECEIVE_RESULTS,
    items: response.data,
    meta: response.meta,
    receivedAt: Date.now()
  };
}

export function fetchResults(query) {
  return (dispatch) => {
    dispatch(requestResults(query));
    // let state = getState();
    // if (JSON.stringify(state.searchresults.query) === JSON.stringify(query) && stillValid(state.searchresults)) {
    //   return dispatch(receiveResults(state.searchresults.items));
    // }
    return post(apiRoutes.query.post(), queryHelper.getURLQuery(query), function (response) {
      dispatch(receiveResults(response));
    });
  };
}


export function changeUIQuery(query) {
  return {
    type: CHANGE_QUERY,
    query: query
  };
}

export function clearQueryResults() {
  return {
    type: CLEAR_QUERY_RESULTS
  };
}



/** WEBPACK FOOTER **
 ** ./src/modules/search/actions.js
 **/